<template>
  <div>
    <van-nav-bar :title="t('comissaoDe.title')" :border="false"
      class="custom-nav-bar sticky-nav">
      <template #left>
        <Button type="back" @click="onClickLeft" />
      </template>
    </van-nav-bar>
    <div class="content-container">
      <div class="w-full px-[15px] flex flex-col items-center">
        <img :src="getAssetsFile('home/headerimgs.png')" alt="" class="w-full" style="object-fit: cover;">
        <img :src="getAssetsFile('home/headertitle.png')" alt="" class="w-[90%] mt-[30px]" style="object-fit: cover;">
        <div class="w-[80%] flex items-center justify-center text-[40px] color-[#FFFFFF] font-bold mt-[10px]">
          <div>{{ t('comissaoDe.blueWhale').split(' ')[0] }}</div>
          <div class="ml-[17px]">{{ t('comissaoDe.blueWhale').split(' ')[1] }}</div>
        </div>
        <div class="text-[15px] color-[#ffffff] mt-[20px] leading-[25px] w-[90%]">
          {{ t('comissaoDe.description.part1') }}
          <span class="color-[#FFFF00]">{{ t('comissaoDe.description.website') }}</span>
          {{ t('comissaoDe.description.part2') }}
          <span class="color-[#FFFF00]">{{ t('comissaoDe.description.amount1') }}</span>
          {{ t('comissaoDe.description.part3') }}
          <span class="color-[#FFFF00]">{{ t('comissaoDe.description.amount2') }}</span>
        </div>
        <div class="tabs" ref="tabsRef">
          <div v-for="(type, idx) in gameTypes" :key="type" :class="['tab', { active: idx === activeTab }]"
            @click="handleTabClick(idx)" ref="tabRefs">
            {{ getGameTypeName(type) }}
          </div>
          <div class="tab-underline" :style="{
            width: underlineStyle.width,
            left: underlineStyle.left,
          }"></div>
        </div>
        <!-- 表格 -->
        <div class="table-wrap">
          <div class="table-header">
            <div class="th">{{ $t('convidarCentro.agentBonusRate.ptmLevel') }}</div>
            <div class="th">{{ $t('convidarCentro.agentBonusRate.level1') }}</div>
            <div class="th">{{ $t('convidarCentro.agentBonusRate.level2') }}</div>
            <div class="th">{{ $t('convidarCentro.agentBonusRate.level3') }}</div>
            <div class="th">{{ $t('convidarCentro.agentBonusRate.level4') }}</div>
            <div class="th">{{ $t('convidarCentro.agentBonusRate.level5') }}</div>
          </div>
          <div v-for="(row, idx) in tableData[activeTab]" :key="row.tier"
            :class="['table-row', { zebra: idx % 2 === 1 }]">
            <div class="td">{{ row.tier }}</div>
            <div class="td">
              <img v-if="row.lv1 === 'lock'" :src="getAssetsFile('activity/tucengse.png')" class="lock-icon"
                alt="lock" />
              <span v-else class="highlight">{{ row.lv1 }}</span>
            </div>
            <div class="td">
              <img v-if="row.lv2 === 'lock'" :src="getAssetsFile('activity/tucengse.png')" class="lock-icon"
                alt="lock" />
              <span v-else class="highlight">{{ row.lv2 }}</span>
            </div>
            <div class="td">
              <img v-if="row.lv3 === 'lock'" :src="getAssetsFile('activity/tucengse.png')" class="lock-icon"
                alt="lock" />
              <span v-else class="highlight">{{ row.lv3 }}</span>
            </div>
            <div class="td">
              <img v-if="row.lv4 === 'lock'" :src="getAssetsFile('activity/tucengse.png')" class="lock-icon"
                alt="lock" />
              <span v-else class="highlight">{{ row.lv4 }}</span>
            </div>
            <div class="td">
              <img v-if="row.lv5 === 'lock'" :src="getAssetsFile('activity/tucengse.png')" class="lock-icon"
                alt="lock" />
              <span v-else class="highlight">{{ row.lv5 }}</span>
            </div>
          </div>
        </div>
        <img :src="getAssetsFile(t('comissaoDe.bottomImage'))" alt="" class="w-[90%] mt-[30px]">
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Button } from "@/components/Button"
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { getPromoterConfig } from '@/api/game' // 请替换为实际API路径
import { getAssetsFile } from '@/utils/pub-use'
import { numberFormat } from '@/utils/formatter'
const router = useRouter()
const { t } = useI18n()

const onClickLeft = () => router.back()
const activeTab = ref(0)
const tabRefs = ref([])
const tabsRef = ref(null)
const underlineStyle = ref({ width: '0px', left: '0px' })

// 动态数据
const gameTypes = ref<string[]>([])
const promoterLevels = ref<any[]>([])
const tableData = ref<any[][]>([])

// 游戏类型映射（使用翻译）
function getGameTypeName(type: string) {
  const gameTypeTranslations = {
    'slot': t('convidarCentro.agentBonusRate.gameTypes.slot'),
    'slots': t('convidarCentro.agentBonusRate.gameTypes.slots'),
    'live': t('convidarCentro.agentBonusRate.gameTypes.live'),
    'sport': t('convidarCentro.agentBonusRate.gameTypes.sport'),
    'fishing': t('convidarCentro.agentBonusRate.gameTypes.fishing'),
    'fish': t('convidarCentro.agentBonusRate.gameTypes.fish'),
    'chess': t('convidarCentro.agentBonusRate.gameTypes.chess'),
    'hall': t('convidarCentro.agentBonusRate.gameTypes.hall'),
    'video_game': t('convidarCentro.agentBonusRate.gameTypes.video_game'),
    'poker': t('convidarCentro.agentBonusRate.gameTypes.poker'),
    'lottery': t('convidarCentro.agentBonusRate.gameTypes.lottery'),
    'esport': t('convidarCentro.agentBonusRate.gameTypes.esport'),
    'virtual': t('convidarCentro.agentBonusRate.gameTypes.virtual')
  }

  return gameTypeTranslations[type as keyof typeof gameTypeTranslations] || type
}

// 获取数据并处理
async function fetchConfig() {
  try {
    const res = await getPromoterConfig()
    // 检查响应结构，确保有正确的数据
    if (res && res.data && res.data.commissionLevelInfo) {
      // 1. 取出所有有用的gameType
      const allTypes = Array.from(new Set(
        res.data.commissionLevelInfo.map((item: any) => item.gameType)
      )).filter((type): type is string => typeof type === 'string')
      gameTypes.value = allTypes

      // 2. 取出所有等级
      promoterLevels.value = res.data.promoterLevelInfo || []

      // 3. 构造表格数据
      tableData.value = allTypes.map(type => {
        // 取出该类型下所有等级的返佣比例
        const typeLevels = res.data.commissionLevelInfo.filter((item: any) => item.gameType === type)

        // 以tier为行，level为列
        const maxTier = 5
        const rows = []

        for (let tier = 1; tier <= maxTier; tier++) {
          const row: any = { tier: `${t('convidarCentro.agentBonusRate.tier')}${tier}` }

          // 遍历所有level (1-5)
          for (let level = 1; level <= 5; level++) {
            // 修正逻辑：Tier1 显示所有 Level 都是相同的比例（使用 Level1 的比例）
            if (level < tier) {
              // 如果 level 小于当前 tier，则显示锁定
              row[`lv${level}`] = 'lock'
            } else {
              // 如果 level >= tier，则显示该 tier 对应的比例
              // Tier1 使用 Level1 的比例，Tier2 使用 Level2 的比例，以此类推
              const targetLevel = tier // 使用当前 tier 作为目标 level
              const found = typeLevels.find((l: any) => l.level === targetLevel)
              if (found && found.ratio !== undefined) {
                const percentage = numberFormat(Number(found.ratio) * 100, { minDecimals: 2 })
                row[`lv${level}`] = `${percentage}%`
              } else {
                row[`lv${level}`] = '0.00%'
              }
            }
          }
          rows.push(row)
        }
        return rows
      })
    }
  } catch (error) {
    console.error('Failed to fetch promoter config:', error)
    // 设置默认值
    gameTypes.value = []
    promoterLevels.value = []
    tableData.value = []
  }
}

// 点击标签时的滚动效果
function handleTabClick(idx: number) {
  activeTab.value = idx
  scrollToTab(idx)
}

// 滚动到指定标签
function scrollToTab(idx: number) {
  nextTick(() => {
    const tabsContainer = tabsRef.value
    const targetTab = tabRefs.value[idx]

    if (tabsContainer && targetTab) {
      const containerWidth = tabsContainer.offsetWidth
      const tabLeft = targetTab.offsetLeft
      const tabWidth = targetTab.offsetWidth
      const scrollLeft = tabsContainer.scrollLeft

      // 计算目标滚动位置
      const targetScrollLeft = tabLeft - (containerWidth / 2) + (tabWidth / 2)

      // 平滑滚动到目标位置
      tabsContainer.scrollTo({
        left: targetScrollLeft,
        behavior: 'smooth'
      })
    }
  })
}

function updateUnderline() {
  nextTick(() => {
    // @ts-ignore
    const tabEl = tabRefs.value[activeTab.value]
    if (tabEl) {
      underlineStyle.value = {
        width: tabEl.offsetWidth + 'px',
        left: tabEl.offsetLeft + 'px'
      }
    }
  })
}

onMounted(async () => {
  await fetchConfig()
  updateUnderline()
})
watch(activeTab, updateUnderline)
</script>

<style scoped>
.custom-nav-bar {
  height: 56px;
  box-shadow: 0px 2px 3px 0px rgba(0,0,0,0.3), 0px -2px 22px 0px rgba(53,189,128,0.61);
  &>* {
    height: 100%;
  }
}
.sticky-nav {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.content-container {
  margin-top: 46px;
}

.bonus-rate-container {
  background: #00563A;
  padding: 0 0 30px 0;
  min-height: 100vh;
}

.tabs {
  display: flex;
  background: #00563A;
  position: relative;
  overflow-x: auto;
  width: 105%;
  margin-top: 30px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.tab {
  flex: 1 0 auto;
  text-align: center;
  padding: 18px 0 10px 0;
  /* 从8px改为10px，增加底部内边距让横线和文字有合适间距 */
  color: #5FB589;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  user-select: none;
  position: relative;
  transition: color 0.2s, background 0.15s;
  z-index: 1;
  min-width: 80px;
}

.tab.active {
  color: #fff;
  font-weight: bold;
}

.tab:active {
  background: #00593D;
  color: #5FB589 !important;
}

.tab-underline {
  position: absolute;
  bottom: 0;
  /* 改回0 */
  height: 2px;
  /* 保持2px高度 */
  background: #009F76;
  border-radius: 2px 2px 0 0;
  transition: left 0.3s, width 0.3s;
  z-index: 2;
}

.table-wrap {
  overflow-x: auto;
}

.table-scroll {
  min-width: 420px;
  /* 从480px改为420px */
}

.table-header {
  display: flex;
  background: #176343;
  color: #fff;
  font-size: 11px;
  padding: 12px 0 8px 0;
  /* 从15px 0 10px 0改为12px 0 8px 0 */
}

.th {
  flex: 1;
  text-align: center;
  min-width: 60px;
  /* 从70px改为60px */
}

.table-row {
  display: flex;
  background: #18553a;
  color: #b6e2d3;
  font-size: 11px;
  padding: 12px 0;
  /* 从16px 0改为12px 0 */
  align-items: center;
  transition: background 0.2s;
}

.table-row.zebra {
  background: #176343;
}

.td {
  flex: 1;
  text-align: center;
  min-width: 60px;
  /* 从70px改为60px */
}

.highlight {
  color: #ffe25a;
  font-weight: bold;
}

.lock-icon {
  width: 14px;
  /* 从16px改为14px */
  height: 14px;
  /* 从16px改为14px */
  display: inline-block;
  vertical-align: middle;
}
</style>

<route lang="json5">
{
  name: 'ComissaoDes',
  meta: {
    title: 'ComissaoDes',
    i18n: 'menus.ComissaoDes'
  },
}
</route>
